export default "__VITE_ASSET__DjtMAbGS__"